import { queryOptions, useQuery } from '@tanstack/react-query'
import ms from 'ms'

import { useCurrentStoreId } from '@hooks/useCurrentStore'
import HttpClient from '@utils/HttpClient.ts'

import type { components, operations } from '@/schema'

export type ScanDTO = components['schemas']['ScanInfoResponse']
export type GetScansResponse = operations['scansForStore']['responses']['200']['content']['application/json']

export type Scan = Omit<ScanDTO, 'scanDate'> & { scanDate: Date }

const scanKeys = {
  all: ['scan'] as const,
  byStore: (storeId: string) => [...scanKeys.all, storeId] as const,
}

export function getScansQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: scanKeys.byStore(storeId),
    queryFn: async () => {
      const result = await HttpClient.get<GetScansResponse>(`/api/store/${storeId}/scans`)
      return result.map(scan => ({ ...scan, scanDate: new Date(scan.scanDate) }))
    },
    staleTime: ms('6h'),
  })
}

export function useScans(storeId: string) {
  return useQuery(getScansQueryOptions(storeId))
}

export function useScansOfCurrentStore() {
  const storeId = useCurrentStoreId()
  return useScans(storeId)
}

export type StoreDayDTO = components['schemas']['DayResponse']

export function getStoreDaysQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: [...scanKeys.byStore(storeId), 'days'],
    queryFn: () => HttpClient.get<StoreDayDTO[]>(`/api/store/${storeId}/days`),
    staleTime: ms('6h'),
  })
}

export function useStoreDays() {
  const storeId = useCurrentStoreId()

  return useQuery(getStoreDaysQueryOptions(storeId))
}
